// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Dgc8J","inputWrap":"CustomTip_inputWrap__mRVeu"};